import React, { useEffect, useState } from "react";
import CardImg from "../assets/login_img.png";
import InputComp from "../components/superAdmin/InputComp";
import { Button } from "@material-tailwind/react";
import { strongPwd } from "../variables/constants";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { postServices } from "../apiServices/apiServices";
import { FiEye, FiEyeOff } from "react-icons/fi";

function LoginPage() {
  const [fieldData, setFieldData] = useState({ username: "", password: "" });
  const [isValid, setIsValid] = useState({ username: true, password: true });
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("gassol-super-admin-token")) {
      navigate("/1");
    } else if (localStorage.getItem("gassol-admin-token")) {
      navigate("/admin/admin_dashboard");
    } else if (localStorage.getItem("gassol-head-branch-token")) {
      navigate("/head_office/dashboard");
    } else if (localStorage.getItem("gassol-sub-branch-token")) {
      navigate("/sub_branch/controller_details");
    }
  }, []);

  const handleUsernameChange = (e) => {
    // if (mailPattern.test(e.target.value) || phoneNumber.test(e.target.value)) {
    // if (phoneNumber.test(e.target.value)) {
    //   setIsValid({ ...isValid, username: true });
    // } else {
    //   setIsValid({ ...isValid, username: false });
    // }
    // setFieldData({ ...fieldData, username: e.target.value });

    const value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
    const limitedValue = value.slice(0, 10); // Limits to 10 digits

    // Validate if the number has 10 digits
    if (limitedValue.length === 10) {
      setIsValid({ ...isValid, username: true }); // Valid if it's exactly 10 digits
    } else {
      setIsValid({ ...isValid, username: false }); // Invalid if it's not 10 digits
    }

    // Update the state with the sanitized and limited value
    setFieldData({ ...fieldData, username: limitedValue });
  };

  const handlePasswordChange = (e) => {
    if (strongPwd.test(e.target.value)) {
      setIsValid({ ...isValid, password: true });
    } else {
      setIsValid({ ...isValid, password: false });
    }
    setFieldData({ ...fieldData, password: e.target.value });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!isValid.username) {
      // toast.error("Invalid email or Phone number.");
      toast.error("Invalid Phone number.");
      setLoading(false);
    } else if (!isValid.password) {
      setLoading(false);
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
    } else {
      try {
        const res = await postServices(`/api/account/signin`, {
          username: "+91" + fieldData.username,
          password: fieldData.password,
        });
        setLoading(false);
        if (res.responseCode === 200) {
          if (res.responseData.role === 1) {
            navigate("/1");
            localStorage.setItem(
              "gassol-super-admin-token",
              res.responseData.access_token
            );
          } else if (res.responseData.role === 2) {
            navigate("/admin/admin_dashboard");
            localStorage.setItem(
              "gassol-admin-token",
              res.responseData.access_token
            );
          } else if (res.responseData.role === 3) {
            navigate("/head_office/dashboard");
            localStorage.setItem(
              "gassol-head-branch-token",
              res.responseData.access_token
            );
          } else if (res.responseData.role === 4) {
            navigate("/sub_branch/controller_details");
            localStorage.setItem(
              "gassol-sub-branch-token",
              res.responseData.access_token
            );
          } else if (res.responseData.role === 5) {
            toast.error("Access denied. Please contact admin");
          }
        } else if (res.responseCode === 202) {
          toast.error("Login credentials are invalid.");
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error);
      }
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className="bg-[#F5F7F9] w-screen h-screen flex justify-center items-center">
      <div className="bg-white px-5 sm:px-12 py-12 sm:py-8 rounded-[50px] shadow-lg grid md:grid-cols-2 items-center xl:gap-0 w-[95%] sm:w-[85%] md:w-full xl:w-[85%]">
        <div className="hidden md:flex justify-center">
          <img src={CardImg} alt="" className="h-[75vh]" />
        </div>
        <form
          className="flex flex-col text-center gap-4"
          onSubmit={handleLoginSubmit}
        >
          <p className="font-bold text-5xl">Welcome Back</p>
          <p className="text-[#BDBDBD] mb-5 sm:mb-8">
            Please login to your account
          </p>

          <div>
            <InputComp
              // label="Email address or Phone *"
              label="Enter Phone number without country code *"
              // type="text"
              type="number"
              onChange={handleUsernameChange}
              value={fieldData.username}
              required={true}
            />
          </div>
          <div className="relative">
            <InputComp
              label="Password *"
              type={isPasswordVisible ? "text" : "password"}
              onChange={handlePasswordChange}
              value={fieldData.password}
              required={true}
            />
            {isPasswordVisible ? (
              <FiEye
                onClick={togglePasswordVisibility}
                className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
              />
            ) : (
              <FiEyeOff
                onClick={togglePasswordVisibility}
                className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
              />
            )}
          </div>
          <div className="flex justify-end">
            <p className="w-fit text-[#BDBDBD] text-sm cursor-pointer">
              Forgot Password?
            </p>
          </div>
          <Button
            type="submit"
            className="bg-[#03438D] font-poppins py-6 rounded-2xl font-normal tracking-[3px]"
            disabled={loading}
          >
            {loading ? "Loading..." : "Login"}
          </Button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
